/* Original clothing artwork + name only. No garment or hat simulation. */
(() => {
  function init(form) {
    if (form.dataset.clothingReady) return;
    const box = form.querySelector('[data-clothing-preview]');
    if (!box) return;
    form.dataset.clothingReady = '1';
    const config = JSON.parse(box.querySelector('[data-clothing-config]').textContent);
    const name = form.querySelector('#custom-name');
    const font = form.querySelector('#custom-font');
    const image = box.querySelector('[data-clothing-image]');
    const status = box.querySelector('[data-clothing-status]');
    const art = box.querySelector('[data-clothing-art]');
    const loading = box.querySelector('[data-clothing-loading]');
    const loadingTitle = box.querySelector('[data-clothing-loading-title]');
    const wait = box.querySelector('[data-clothing-wait]');
    const enlarge = box.querySelector('[data-clothing-enlarge]');
    const dialog = box.querySelector('[data-clothing-dialog]');
    const large = box.querySelector('[data-clothing-large]');
    let timer, waitTimer, controller, serial = 0, objectURL;
    const design = () => (form.querySelector('#cloth_design-options input:checked')?.dataset.key || 'Tiger').toLowerCase();
    const fontLabels = {'cooper-black-std':'Cooper Black','dirty-bakers-dozen-scorch':'Dirty Bakers Dozen Scorch','bello-pro':'Bello Pro',duckie:'Duckie',orbe:'Orbe',nelson:'Nelson','embryo-open':'Embryo Open','orgovan-flower-power':'Orgovan Flower Power','cc-phat-boi-bold':'CC Phat Boi Bold','hansson-stencil-mn':'Hansson Stencil MN',moussescript:'Mousse Script'};
    function updateSummary() {
      const values = {design:form.querySelector('#cloth_design-options input:checked')?.value,name:name.value.trim() || '—',font:fontLabels[font.value] || font.value,colour:form.querySelector('#cloth-colour-options input:checked')?.value};
      Object.entries(values).forEach(([key,value]) => { const node=form.querySelector('[data-clothing-summary-'+key+']'); if(node) node.textContent=value || '—'; });
    }
    function applyFont() { font.style.fontFamily = font.value; }
    function clearURL() { if (objectURL) { URL.revokeObjectURL(objectURL); objectURL = null; } }
    function cancel() { clearTimeout(timer); clearTimeout(waitTimer); controller?.abort(); ++serial; }
    function setLoading(active) {
      clearTimeout(waitTimer);
      loading.hidden = !active;
      art.setAttribute('aria-busy', String(active));
      enlarge.disabled = active;
      if (!active) { delete box.dataset.loading; return; }
      box.dataset.loading = 'true';
      loadingTitle.textContent = config.loading;
      wait.textContent = config.wait;
      status.textContent = config.loading + ' ' + config.wait;
      const current = serial;
      waitTimer = setTimeout(() => {
        if (current !== serial || loading.hidden) return;
        wait.textContent = config.slow;
        status.textContent = config.loading + ' ' + config.slow;
      }, 30000);
    }
    async function update() {
      cancel();
      const current = serial;
      const motif = design();
      applyFont();
      updateSummary();
      clearURL();
      image.src = config.art[motif];
      if (!name.value.trim()) {
        setLoading(false); status.textContent = config.empty; return;
      }
      controller = new AbortController();
      setLoading(true);
      try {
        const response = await fetch(config.endpoint, {method:'POST', headers:{'Content-Type':'application/json'}, signal:controller.signal,
          body:JSON.stringify({design:motif, name:name.value.trim(), font:font.value})});
        if (!response.ok || !response.headers.get('content-type')?.startsWith('image/png')) throw new Error('Preview unavailable');
        const blob = await response.blob();
        if (current !== serial) return;
        objectURL = URL.createObjectURL(blob); image.src = objectURL;
        try { await image.decode(); } catch (_) {}
        if (current !== serial) return;
        status.textContent = '';
      } catch (error) {
        if (error.name !== 'AbortError' && current === serial) status.textContent = config.error;
      } finally {
        if (current === serial) setLoading(false);
      }
    }
    name.addEventListener('input', () => { cancel(); updateSummary(); if (!name.value.trim()) { update(); return; } setLoading(true); timer=setTimeout(update,350); });
    font.addEventListener('change', update);
    form.querySelectorAll('#cloth_design-options input').forEach(input => input.addEventListener('change',update));
    form.querySelectorAll('#cloth-colour-options input').forEach(input => input.addEventListener('change',() => {
      updateSummary();
      const chosen=form.querySelector('#cloth-colour-options input:checked');
      const thumb=form.closest('[data-clothing-product]')?.querySelector('[data-clothing-photo][data-photo-index="'+chosen.dataset.photoIndex+'"]');
      thumb?.click();
    }));
    enlarge.addEventListener('click', () => { large.src=image.src; dialog.showModal(); });
    box.querySelector('[data-clothing-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target===dialog) dialog.close(); });
    window.addEventListener('pageshow', () => { applyFont(); update(); });
    applyFont(); update();
  }
  function initGallery(gallery) {
    if(gallery.dataset.clothingGalleryReady) return;
    gallery.dataset.clothingGalleryReady='1';
    const hero=gallery.querySelector('[data-clothing-photo-open]');
    const image=hero.querySelector('img');
    const dialog=gallery.querySelector('[data-clothing-photo-dialog]');
    const large=gallery.querySelector('[data-clothing-photo-large]');
    const thumbs=gallery.querySelectorAll('[data-clothing-photo]');
    thumbs.forEach(thumb=>thumb.addEventListener('click',()=>{
      image.removeAttribute('srcset');image.src=thumb.dataset.photoSrc;image.alt=thumb.dataset.photoAlt;hero.href=thumb.dataset.photoFull;
      thumbs.forEach(node=>node.setAttribute('aria-pressed',String(node===thumb)));
    }));
    hero.addEventListener('click',event=>{event.preventDefault();large.src=hero.href;large.alt=image.alt;dialog.showModal();});
    gallery.querySelector('[data-clothing-photo-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
  }
  const initAll = () => {document.querySelectorAll('[data-clothing-gallery]').forEach(initGallery);document.querySelectorAll('[data-atelier-clothing]').forEach(init);};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initAll); else initAll();
  document.addEventListener('shopify:section:load',initAll);
})();
